import { ButtonLink } from "@/components/ui/button";
import S from "./index.module.scss";
import { FC } from "react";
import { useTranslations } from "next-intl";
import HeaderBackground from "@/components/ui/header-background";

type ErrorProps = {
  title?: string;
  text: string;
};

const Error: FC<ErrorProps> = ({ title, text }) => {
  const t = useTranslations();

  return (
    <div>
      <HeaderBackground type="black" />
      <div className={S.wrapper}>
        <h1 className={S.title}>{title ?? t("error.wrong")}</h1>
        <p className={S.text}>{text}</p>
        <ButtonLink variant="white" href="/">
          {t("home")}
        </ButtonLink>
      </div>
    </div>
  );
};

export default Error;
